// extracted by mini-css-extract-plugin
export default {"card":"convert_card__h8fmc"};